// extracted by mini-css-extract-plugin
module.exports = {"content":"WorkType_content__1H5eX","submitBtn":"WorkType_submitBtn__1EyAC"};